import Head from "next/head";
import { FaGhost } from "react-icons/fa";
import styles from "../styles/Custom404.module.scss";
export default function Custom500() {
  return (
    <>
      <Head>
        <title>MagicalTrip: 500 Internal Server Issue</title>
      </Head>
      <main className={styles.Custom404}>
        <h1>
          5
          <span>
            <FaGhost />
          </span>
          0
        </h1>
        <h2>Error: 500 Internal Server Issue</h2>
        <p>
          We are experiencing some server issues, please refresh the page or
          retry in a few minutes.
        </p>
      </main>
    </>
  );
}
